import { ListItemButton, ListItemText, Paper, List } from "@mui/material";
import { useHistory } from "react-router-dom";
import WorkLogSummary from "../../models/WorkLogSummary";
import { Routes } from "../../types/Routes";
import icon from "../../img/icons/work_logs.svg"
import OpsPanel from "../OpsPanel";

interface Props {
  /**
   * The list of worklogs
   */
  rows: WorkLogSummary[];
}

export default function MissingWorklogsTile({ rows }: Props) {
  const history = useHistory();

  const handlePluralDays = (instance: number, message: string) => {
    if (instance === 1) {
      return message.slice(0, -1);
    }
    return message;
  };

  const updateCurrentHistoryEntry = (assignationExternalId?: string) => {
    history.replace(`${Routes.WORKLOG}?assignation=${assignationExternalId}`);
  };

  return rows.length > 0 ? (
    <OpsPanel
      title="Missing Worklogs"
      icon={icon}
    >
      <Paper elevation={0} style={{ minHeight: "15.5em", maxHeight: "15.5em", overflow: "auto" }}>
        <List disablePadding>
          {rows.map((row, index) => (
            <ListItemButton alignItems="flex-start" disableGutters dense key={`dtile-${index}`}>
              <ListItemText
                primary={`${row.projectName} - ${row.positionName}`}
                secondary={handlePluralDays(row.missingDays, `${row.missingDays} missing days`)}
                onClick={() => updateCurrentHistoryEntry(row.assignationExternalId)}
                primaryTypographyProps={{ fontWeight: "bold" }}
              />
            </ListItemButton>
          ))}
        </List>
      </Paper>
    </OpsPanel>
  ) : null;
}
